import { render, staticRenderFns } from "./bill-form-receive.vue?vue&type=template&id=7422fa74&scoped=true"
import script from "./bill-form-receive.vue?vue&type=script&lang=js"
export * from "./bill-form-receive.vue?vue&type=script&lang=js"
import style0 from "./bill-form-receive.vue?vue&type=style&index=0&id=7422fa74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7422fa74",
  null
  
)

export default component.exports